'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var Status = (0, _immutable.Record)({
  source: null,
  messageStatus: null,
  timestamp: null,
  sendFailure: null
}, 'Status');

exports.default = Status;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/records/Status.js
// module id = 379
// module chunks = 2 3